import styled from "styled-components";
import { Icon } from "../../../../../../../base/icons/icon/index.js";
import Image from "../../../../../../../base/multimedia/image/index.js";
import { InnerMarkdownHTML } from "../../../../../../../base/text/inner-markdown-HTML/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const ProductItemContainer = styled.a.withConfig({
    displayName: "styled__ProductItemContainer",
    componentId: "sc-dfffa0e1-0"
})`
	${FlexMixin({
    direction: 'column'
})}
	border: 1px solid ${({ theme  })=>theme.colors.grays.light};
	height: 100%;
	width: 160px;
`;
export const ProductItemImage = styled.div.withConfig({
    displayName: "styled__ProductItemImage",
    componentId: "sc-dfffa0e1-1"
})`
	position: relative;
`;
export const ProductImage = styled(Image).withConfig({
    displayName: "styled__ProductImage",
    componentId: "sc-dfffa0e1-2"
})``;
export const ProductItemPriceContainer = styled.span.withConfig({
    displayName: "styled__ProductItemPriceContainer",
    componentId: "sc-dfffa0e1-3"
})`
	background-color: ${({ theme  })=>theme.colors.secondary.base};
	bottom: 0;
	color: ${({ theme  })=>theme.colors.white.base};
	padding: 8px 12px;
	position: absolute;
	right: 0;
	text-align: right;
`;
export const ProductItemPriceFrom = styled.span.withConfig({
    displayName: "styled__ProductItemPriceFrom",
    componentId: "sc-dfffa0e1-4"
})`
	${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'small'
})}
	display: block;
`;
export const ProductItemPrice = styled.span.withConfig({
    displayName: "styled__ProductItemPrice",
    componentId: "sc-dfffa0e1-5"
})`
	${FontMixin({
    size: 'large',
    weight: 'medium',
    height: 'medium'
})}
`;
export const ProductItemContent = styled.div.withConfig({
    displayName: "styled__ProductItemContent",
    componentId: "sc-dfffa0e1-6"
})`
	flex-grow: 1;
	padding: 10px 12px;
`;
export const ProductItemTitle = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__ProductItemTitle",
    componentId: "sc-dfffa0e1-7"
})`
	${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})}
	color: ${({ theme  })=>theme.colors.grays.darker};
`;
export const ProductItemDesc = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__ProductItemDesc",
    componentId: "sc-dfffa0e1-8"
})`
	${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'medium'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
`;
export const ProductItemSearch = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__ProductItemSearch",
    componentId: "sc-dfffa0e1-9"
})`
	${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'medium'
})}
	color: ${({ theme  })=>theme.colors.grays.base};
`;
export const ProductItemFooter = styled.div.withConfig({
    displayName: "styled__ProductItemFooter",
    componentId: "sc-dfffa0e1-10"
})`
	${FlexMixin()}
	border-top: 1px solid ${({ theme  })=>theme.colors.grays.light};
	flex-grow: 0;

	& > div {
		${FlexMixin({
    direction: 'column',
    align: 'center'
})}
		${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'medium'
})}
		border-right: 1px solid ${({ theme  })=>theme.colors.grays.light};
		color: ${({ theme  })=>theme.colors.grays.dark};
		padding: 10px 2px 9px;
		width: 33.33%;
	}

	${Icon} {
		${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'small'
})}
	}
`;

//# sourceMappingURL=styled.js.map